module.exports = __webpack_public_path__ + "img/skilllist_4.8a646481.png";